import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PatrolFrontDeskList from './components/PatrolFrontDeskList';

const { Cell } = ResponsiveGrid;

const CleanFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="巡邏前台"
        // description="巡邏前台"
        breadcrumbs={[
          {
            name: '巡邏管理',
          },
          {
            name: '巡邏前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PatrolFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default CleanFrontDesk;
